import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const ClientsReview = createApi({
	reducerPath: "ClientsReview",
	baseQuery: fetchBaseQuery({
		baseUrl: "https://flit-backend.developer-ourbase-camp.com/api/",
	}),
	endpoints: (builder) => {
		return {
			clientsReviews: builder.query({
				query: () => {
					return {
						url: "client_reviews",
						method: "GET",
					};
				},
			}),
		};
	},
});
export const { useClientsReviewsQuery } = ClientsReview;
export default ClientsReview;
